import cn from 'classnames';
import { TYPE_BUTTONS } from '../../../../constans';
import NavLink from '../../Elements/Link/NavLink';
import styles from './styles.module.scss';

const Button = ({
  type = '',
  onClick = _ => _,
  disabled = false,
  style,
  stopPropagation = true,
  className,
  image = '',
  to = '',
  children,
  ...props
}) => {
  return to.length > 0 ? (
    <NavLink
      className={cn(
        styles.button_base,
        className,
        props.styles,
        type === TYPE_BUTTONS.BLUE && styles.button_blue,
        type === TYPE_BUTTONS.GREY && styles.button_grey,
        type === TYPE_BUTTONS.WHITE && styles.button_white,
        type === TYPE_BUTTONS.GREEN && styles.button_green,
        type === TYPE_BUTTONS.ORANGE && styles.button_green,

      )}
      disabled={disabled}
      to={to}
      style={style}
      {...props}
    >
      {children}
    </NavLink>
  ) : (
    <button
      type="button"
      className={cn(
        className,
        styles.button_base,
        type === TYPE_BUTTONS.BLUE && styles.button_blue,
        type === TYPE_BUTTONS.GREY && styles.button_grey,
        type === TYPE_BUTTONS.WHITE && styles.button_white,
        type === TYPE_BUTTONS.GREEN && styles.button_green,
        type === TYPE_BUTTONS.RED && styles.button_red,
        props.styles,
      )}
      disabled={disabled}
      onClick={e => {
        if (stopPropagation) {
          e.stopPropagation();
        }
        onClick();
      }}
      style={style}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
